<template>
  <el-dialog
    class="orderTip"
    title="提示"
    :visible.sync="tipVisible"
    width="422px"
    :before-close="handleClose"
  >
    <h3><i :style="`color:${color[tipType]}`" class="el-icon-warning" />{{ text[tipType] }} </h3>
    <div v-if="tipType == 1">删除后您可以在订单回收站还原该订单</div>
    <div v-if="tipType == 2">取消申请后可以重新发起售后申请</div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    tipVisible: {
      type: Boolean
    },
    tipType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      color: [
        '#F79118',
        '#EC212D',
        '#EC212D',
        '#EC212D'
      ],
      text: [
        '您确定要还原该订单吗？',
        '您确定要删除该订单吗？',
        '您确定要取消售后申请吗？',
        '您确定要取消审批吗？'
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeTips', false)
    },
    confirm() {
      this.$emit('cfmTips', this.tipType)
    }
  }
}
</script>

<style lang='scss'>
.orderTip {
    .el-dialog {
        border-radius: 6px;
        .el-dialog__header {
            position: relative;
            padding-left: 16px;
            background-color: #fff;
            border-radius: 6px 6px 0 0;
            .el-dialog__title {
                height: 24px;
                line-height: 24px;
                position: absolute;
                bottom: 0;
                color: #333;
            }
            .el-dialog__headerbtn {
                top: 24px;
            }
            .el-icon-close {
                color: #C0C5CF;
            }
        }
        .el-dialog__body {
            padding: 18px 16px;
            h3 {
                height: 22px;
                line-height: 22px;
                font-size: 16px;
                color: #333;
                .el-icon-warning {
                    font-size: 22px;
                    margin-right: 13px;
                }
            }
            div {
                font-size: 14px;
                color: #666666;
                padding-left: 35px;
                margin-top: 12px;
            }
        }
        .el-dialog__footer {
            padding: 10px 20px;
        }
    }
}
</style>
